"use client";
import { useI18n } from "@/i18n/provider";
import { clientMessages } from "@/i18n/client-messages";
import { useEffect, useState } from "react";
import { CopyIcon } from "./icons";

export function CopyButton({ value, label, className = "button button-outline button-small" }: { value: string; label?: string; className?: string }) {
  const { locale } = useI18n();
  const t = clientMessages[locale];
  const [state, setState] = useState<"idle" | "copied" | "failed">("idle");
  useEffect(() => { if (state === "idle") return; const timer = window.setTimeout(() => setState("idle"), 3000); return () => window.clearTimeout(timer); }, [state]);
  async function copy() { try { await navigator.clipboard.writeText(value); setState("copied"); } catch { setState("failed"); } }
  return <span className="copy-control"><button type="button" className={className} onClick={() => void copy()}><CopyIcon />{state === "copied" ? t.copied : label ?? t.copy}</button><span className={state === "failed" ? "copy-error" : "sr-only"} role="status">{state === "failed" ? t.copyFailed : state === "copied" ? t.clipboardCopied : ""}</span></span>;
}
